import axios from "./axios_interceptor";
import { get_jwt_token, loginRedirect } from "./helper_funtions";

export const generateSecretKey = async () => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/web_apps/device/secret-key/`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message };
  }
};

export const downloadAgent = async (osType) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
      params:{os:osType},
    };
    const url = `/web_apps/device/download-agent/`;
    const response = await axios.get(url, config);
    
    // Return the blob data for the component to handle download
    return { data: response.data, error: null };
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const json = JSON.parse(text);
        return { data: null, error: json };
      } catch {
        return { data: null, error: { error: "UNKNOWN_ERROR" } };
      }
    }
    return { data: null, error: error.response?.data?.errors || error.message };
  }
};
